import type { CollectionsApi } from '@wix/wix-code-collections-api'
import { addField, updateSchema } from '@wix/wix-code-collections-api'
import { FieldType } from '@wix/wix-data-schema-types'
import { MAIN_SLUG_FIELD_DISPLAY_NAME, MAIN_SLUG_FIELD_KEY } from './constants'
import { hasMainSlugField } from './hasSlugField'

const addMainSlugField = async ({
  collectionsApi,
  collectionId,
  displayField,
}: {
  collectionsApi: CollectionsApi
  collectionId: string
  displayField: string
}) => {
  await collectionsApi.execute(
    updateSchema(
      collectionId,
      addField(MAIN_SLUG_FIELD_KEY, {
        type: FieldType.slug,
        displayName: MAIN_SLUG_FIELD_DISPLAY_NAME,
        pattern: `{${displayField}}`,
      }),
    ),
  )
}

export const addMainSlugFieldIfNotExists = async ({
  collectionsApi,
  collectionId,
}: {
  collectionsApi: CollectionsApi
  collectionId: string
}) => {
  const schema = await collectionsApi.get(collectionId)

  if (!hasMainSlugField(schema)) {
    const { displayField, id } = schema

    if (!displayField) {
      throw new Error(
        'Cannot add Slug field because display field does not exist',
      )
    }

    await addMainSlugField({
      collectionsApi,
      displayField,
      collectionId: id,
    })
  }
}
